import type { IQueueStorage, QueuedEventRecord } from './types';

export class MemoryQueueStorage implements IQueueStorage {
  private records: QueuedEventRecord[] = [];

  init(): void {
    // no-op
  }

  destroy(): void {
    this.records = [];
  }

  load(): readonly QueuedEventRecord[] {
    return [...this.records];
  }

  save(records: readonly QueuedEventRecord[]): void {
    this.records = [...records];
  }

  getAdapterName(): string {
    return 'MemoryQueueStorage';
  }

  isAvailable(): boolean {
    return true;
  }
}
